module.exports = __webpack_public_path__ + "img/img13.3beaee4f.png";